var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.booking)?_c('div',[_c('booking-nav',{attrs:{"booking":_vm.booking}}),_c('booking-form',{attrs:{"booking":_vm.booking,"bikes":_vm.bikes},on:{"submit":_vm.save}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }